import { any, apiDate, number, optional, string, zintersection, zodLess, ZodLessInfer, zrecord } from '@kaiizen/zod-less';

// ****************************************************************************************
// Legacy BackgroundJob record schema.
//
// This is the generic, untyped record shape returned by the **bespoke** job kickoffs that
// predate the generic API (`exportScopeReportPdf`, `exportScopePurchaseOrderExcel`, …) and it
// backs the bespoke scan-video progress views. It is intentionally left in place: those flows
// are not being converted yet. New generic work goes through the typed Operation API —
// `ApiOperationSchema` (see ApiOperationSchema.ts / ASYNC_OPERATION_API_RFC.md).
// ****************************************************************************************

export const JobLifecycleStatusSchema = zodLess('created|started|failed|completed');
export type JobLifecycleStatus = ZodLessInfer<typeof JobLifecycleStatusSchema>;

/**
 * Dynamic, job-reported current-stage snapshot (overwritten in place as a job advances) —
 * the "where is this job right now" view, distinct from the coarse `lifecycleStatus`.
 * `percent` is intentionally omitted: clients derive it from `stepIndex`/`totalSteps`.
 */
export const ApiJobProgressSchema = zodLess({
  phase: string,
  message: optional(string),
  stepIndex: optional(number),
  totalSteps: optional(number),
  updatedAt: string,
});
export type ApiJobProgress = ZodLessInfer<typeof ApiJobProgressSchema>;

export const ApiBackgroundJobSchema = zodLess({
  id: string,
  userId: optional(string),
  input: zintersection({ jobType: string }, zrecord(any)),
  output: any,
  lifecycleStatus: JobLifecycleStatusSchema,
  // null when the job has reported no progress yet (e.g. jobs not instrumented for progress)
  progress: optional(ApiJobProgressSchema.nullable()),
  createdAt: apiDate,
  updatedAt: apiDate,
});
export type ApiBackgroundJob = ZodLessInfer<typeof ApiBackgroundJobSchema>;
